import { Component, signal, computed, inject, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgClass } from '@angular/common';
import { AuthService } from '../../../_core/services/auth.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HasRoleDirective } from '../../../_core/directives/has-role.directive';
import { FunctionalitiesService } from '../../../_core/services/functionalities.service';
import { MenuOption } from '../../../_core/models/menu-options';
import { AdminService } from '../../../_core/services/admin.service';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule, NgClass, RouterModule, FormsModule, HasRoleDirective],
  templateUrl: './header.html',
})
export class HeaderComponent {
  @ViewChild('issueDialog') issueDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('issueImageInput') issueImageInput?: ElementRef<HTMLInputElement>;

  debug = false;
  menuOptions: MenuOption[] = [];
  reportTitle = signal('');
  reportDescription = signal('');
  reportPriority = signal<'low' | 'normal' | 'high' | 'critical'>('normal');
  reportSaving = signal(false);
  reportError = signal<string | null>(null);
  screenshotError = signal<string | null>(null);
  screenshotPreviewUrl = signal<string | null>(null);
  screenshotBase64 = signal<string | null>(null);
  screenshotMimeType = signal<string | null>(null);
  screenshotFileName = signal<string | null>(null);

  constructor(srvFunctionalities:FunctionalitiesService){
  this.menuOptions = srvFunctionalities.menuOptions;



  }
  async ngOnInit() {
    //const jwtRole = await this.auth.getRole();

    //this.role.set(jwtRole ?? 'guest');
  }
  private auth = inject(AuthService);
  private adminService = inject(AdminService);
  readonly router = inject(Router);
  private toastr = inject(ToastrService);


  menuOpen = signal(false);

  toggleMenu() {

    this.menuOpen.update(v => {

      document.body.style.overflow = v ? '' : 'hidden';
      return !v;

    });

  }


  filteredMenu = computed(() => {
    const userRoles = this.auth.roles();
    if (this.debug) console.log(userRoles);
    //console.log('[Menu] user roles:', userRoles);

    return this.menuOptions.filter(item =>
      item.roles.some(r => userRoles.includes(r))
    );

  });

  desktopLogoutItem = computed(() =>
    this.filteredMenu().find(item => String(item.link ?? '').trim() === '/auth/logout') ?? null
  );

  desktopMenuItems = computed(() =>
    this.filteredMenu().filter(item => String(item.link ?? '').trim() !== '/auth/logout')
  );

  mobileLogoutItem = computed(() =>
    this.filteredMenu().find(item => String(item.link ?? '').trim() === '/auth/logout') ?? null
  );

  mobileMenuItems = computed(() =>
    this.filteredMenu().filter(item => String(item.link ?? '').trim() !== '/auth/logout')
  );
  protected readonly title = signal('propTrading');

  openIssueDialog() {
    this.reportError.set(null);
    const dialog = this.issueDialog?.nativeElement;
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
  }

  closeIssueDialog(force = false) {
    if (!force && this.reportSaving()) {
      return;
    }

    const dialog = this.issueDialog?.nativeElement;
    if (dialog?.open) {
      dialog.close();
    }

    this.reportTitle.set('');
    this.reportDescription.set('');
    this.reportPriority.set('normal');
    this.reportError.set(null);
    this.screenshotError.set(null);
    this.screenshotPreviewUrl.set(null);
    this.screenshotBase64.set(null);
    this.screenshotMimeType.set(null);
    this.screenshotFileName.set(null);
    const input = this.issueImageInput?.nativeElement;
    if (input) {
      input.value = '';
    }
  }

  async submitIssueReport() {
    const title = String(this.reportTitle() ?? '').trim();
    const description = String(this.reportDescription() ?? '').trim();

    if (!title) {
      this.reportError.set('Title is required.');
      return;
    }

    if (!description) {
      this.reportError.set('Description is required.');
      return;
    }

    this.reportSaving.set(true);
    this.reportError.set(null);

    try {
      await this.adminService.createIssueReport({
        title,
        description,
        priority: this.reportPriority(),
        app_section: this.currentAppSection(),
        page_path: this.router.url,
        screenshot_base64: this.screenshotBase64(),
        screenshot_mime_type: this.screenshotMimeType()
      });

      this.toastr.success('Issue report submitted', 'Support');
      this.closeIssueDialog(true);
    } catch (err: any) {
      const message = String(err?.message ?? 'Error submitting issue report.');
      this.reportError.set(message);
      this.toastr.error(message, 'Support');
    } finally {
      this.reportSaving.set(false);
    }
  }

  onIssueDialogCancel(event: Event) {
    event.preventDefault();
    this.closeIssueDialog();
  }

  onIssueDialogBackdrop(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeIssueDialog();
    }
  }

  openIssueImagePicker() {
    if (this.reportSaving()) {
      return;
    }
    this.issueImageInput?.nativeElement?.click();
  }

  async onIssueImageSelected(event: Event) {
    const input = event.target as HTMLInputElement | null;
    const file = input?.files?.[0] ?? null;
    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.screenshotError.set('Please select an image file.');
      this.screenshotPreviewUrl.set(null);
      this.screenshotBase64.set(null);
      this.screenshotMimeType.set(null);
      this.screenshotFileName.set(null);
      if (input) input.value = '';
      return;
    }

    try {
      const dataUrl = await this.readFileAsDataUrl(file);
      const base64 = String(dataUrl.split(',')[1] ?? '').trim();
      if (!base64) {
        throw new Error('Empty image payload.');
      }

      this.screenshotError.set(null);
      this.screenshotPreviewUrl.set(dataUrl);
      this.screenshotBase64.set(base64);
      this.screenshotMimeType.set(file.type || 'image/png');
      this.screenshotFileName.set(file.name || 'attachment');
    } catch (err: any) {
      this.screenshotError.set(String(err?.message ?? 'Unable to read the selected image.'));
      this.screenshotPreviewUrl.set(null);
      this.screenshotBase64.set(null);
      this.screenshotMimeType.set(null);
      this.screenshotFileName.set(null);
      if (input) input.value = '';
    }
  }

  clearIssueImage() {
    this.screenshotError.set(null);
    this.screenshotPreviewUrl.set(null);
    this.screenshotBase64.set(null);
    this.screenshotMimeType.set(null);
    this.screenshotFileName.set(null);
    const input = this.issueImageInput?.nativeElement;
    if (input) {
      input.value = '';
    }
  }

  private currentAppSection(): string | null {
    const parts = String(this.router.url ?? '')
      .split('?')[0]
      .split('/')
      .map(part => part.trim())
      .filter(Boolean);

    if (!parts.length) return null;
    return parts.slice(0, 2).join('/');
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result ?? ''));
      reader.onerror = () => reject(new Error('Unable to read the selected image.'));
      reader.readAsDataURL(file);
    });
  }
}
